"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "email-address-input",
    props: {
        initValue: {
            type: String,
            default: ""
        }
    },
    data: function () {
        return {
            name: "email-address-input",
            value: this.initValue
        };
    },
    methods: {
        isValid: function (emitValidation) {
            if (emitValidation === void 0) { emitValidation = false; }
            if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.value)) {
                return true;
            }
            if (emitValidation) {
                this.$emit("invalid");
            }
        },
        updateValue: function (value) {
            this.value = value;
            this.$emit("input", value);
        },
        onBlur: function () {
            this.appendValidationClass();
        },
        appendValidationClass: function () {
            var ref = this.$refs.emailAddress;
            if (!ref || !ref.classList) {
                return;
            }
            if (this.isValid()) {
                ref.classList.remove("is-invalid");
                ref.classList.add("is-valid");
            }
            else {
                ref.classList.remove("is-valid");
                ref.classList.add("is-invalid");
            }
        }
    }
});
